import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../utils/env';
import { Examiner, ExaminersResponse } from './examiners.types';
import { addParam, addParamsList } from '../../utils/servicesHelper';
import { getExamCommitteeId } from '../../pages/SampleAssessmentRepo/Helpers/AccountTypeRendering';

async function getExaminerDetailsFromApi(id: string) {
  const response = await axios.get(`${EnvWindow.REACT_APP_EXAMINERS_API_URL}/Examiners/${id}`);
  return response.data;
}

async function getExaminersApi(
  signal?: AbortSignal,
  pageSize = 0,
  pageNumber = 20,
  sortByProperty?: string,
  isDescending?: boolean,
  firstName?: string,
  lastName?: string,
  email?: string,
  pesel?: string,
  phone?: string,
  examCommitteeFilter?: string,
  status?: string,
  examCommitteeFilterList: string[] | number[] = getExamCommitteeId(examCommitteeFilter),
): Promise<AxiosResponse<ExaminersResponse>> {
  phone = phone?.replace('+', '%2B');
  let params = '';
  params += addParam('firstName', firstName ? firstName : '');
  params += addParam('lastName', lastName ? lastName : '');
  params += addParam('pesel', pesel ? pesel : '');
  params += addParam('phone', phone ? phone : '');
  params += addParam('email', email ? email : '');
  params += addParamsList(
    'examCommitteeEnumFilter',
    examCommitteeFilterList.length > 0 ? examCommitteeFilterList : [],
  );
  params += addParam(
    'isOnline',
    status !== '' && status !== 'true,false' ? status : '',
  );
  params += addParam(
    'sortByProperty',
    sortByProperty !== 'status' && sortByProperty !== '' ? sortByProperty : 'isOnline',
  );
  params += addParam('isDescending', isDescending ? isDescending : '');
  return await axios.get(
    `${EnvWindow.REACT_APP_EXAMINERS_API_URL}/Query?page=${pageNumber}&pageSize=${pageSize}${params}`,
    { signal: signal ?? undefined },
  );
}

async function getExaminerById(id: string): Promise<AxiosResponse<Examiner>> {
  return await axios.get(`${EnvWindow.REACT_APP_EXAMINERS_API_URL}/${id}`);
}

export { getExaminerDetailsFromApi, getExaminersApi, getExaminerById };
